import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Button,
  Icon,
  Copy,
  Bold
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import { dismissMobileKeyboard } from "app/NativeActions";

class BottomButtons extends Component {
  renderMentionButton() {
    return (
      <Button
        onPress={() => {
          this.props.updateMessageProp({
            prop: "mention_tracker",
            value: !this.props.mention_tracker
          });
        }}
        tooltip={"Mention Team Member"}
        tooltipPlacement={"top"}
      >
        <Copy style={{ fontSize: 22 }}>
          <Bold>@</Bold>
        </Copy>
      </Button>
    );
  }

  renderPostNoteButton() {
    if (!this.props.disabled) {
      return (
        <PillButton
          innerStyle={{
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 10,
            paddingRight: 10
          }}
          primary={true}
          onPress={() => {
            dismissMobileKeyboard();

            this.props.onSubmit({
              message: this.props.message,
              onSuccess: () => {
                this.props.updateMessageProp({
                  prop: "message",
                  value: ""
                });
              }
            });
          }}
        >
          Post Note
        </PillButton>
      );
    }
  }

  render() {
    return (
      <Row
        style={{
          padding: 15,
          paddingTop: 10,
          paddingBottom: 10
        }}
      >
        <Row>{this.renderMentionButton()}</Row>
        <Wrapper style={{ flex: 1 }} />
        {this.renderPostNoteButton()}
      </Row>
    );
  }
}

export default BottomButtons;
